import BaseAPI from '@/apis/base/baseApi';

export default class DvcApi extends BaseAPI {
  apiName = 'DVC';
}
